import React from "react";
import ReactApexChart from "react-apexcharts";
import { Card, Row, Col } from "reactstrap";

const Mixed = ({ incomeAnnualData }) => {
  //横軸
  const horizontalAxis = incomeAnnualData.map((array) => array.node.fiscalYear);

  //会費
  const memberFee = incomeAnnualData.map((array) =>
    parseInt(array.node.memberFee.replace(/,/g, ""))
  );

  //寄付金
  const donation = incomeAnnualData.map((array) =>
    parseInt(array.node.donation.replace(/,/g, ""))
  );

  //自主事業
  const businessRevenue = incomeAnnualData.map((array) =>
    parseInt(array.node.businessRevenue.replace(/,/g, ""))
  );

  //受託事業
  const trusteeRevenue = incomeAnnualData.map((array) =>
    parseInt(array.node.trusteeRevenue.replace(/,/g, ""))
  );
  //助成金
  const subsidy = incomeAnnualData.map((array) =>
    parseInt(array.node.subsidy.replace(/,/g, ""))
  );
  //助成金
  const bounty = incomeAnnualData.map((array) =>
    parseInt(array.node.bounty.replace(/,/g, ""))
  );

  //助成・補助金
  const government = incomeAnnualData.map(
    (array) =>
      parseInt(array.node.subsidy.replace(/,/g, "")) +
      parseInt(array.node.bounty.replace(/,/g, ""))
  );

  //その他収益
  const miscellaneous = incomeAnnualData.map((array) =>
    array.node.miscellaneous.replace(/,/g, "")
  );

  //グラフデータ
  const dataSeries = [
    {
      name: "会費",
      data: memberFee,
    },
    {
      name: "寄付金",
      data: donation,
    },
    {
      name: "自主事業",
      data: businessRevenue,
    },
    {
      name: "受託事業",
      data: trusteeRevenue,
    },
    {
      name: "助成金",
      data: subsidy,
    },
    {
      name: "補助金",
      data: bounty,
    },
    {
      name: "その他収益",
      data: miscellaneous,
    },
  ];

  //グラフオプション
  const dataOptions = {
    chart: {
      type: "bar",
      height: 350,
      stacked: true,
      toolbar: {
        show: false,
      },
      // zoom: {
      //   enabled: true,
      // },
    },
    grid: {
      xaxis: {
        lines: {
          show: false,
        },
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: {
            position: "bottom",
            offsetX: -10,
            offsetY: 0,
          },
        },
      },
    ],
    plotOptions: {
      bar: {
        horizontal: false,
      },
    },
    dataLabels: {
      enabled: false,
      formatter(value) {
        return value.toLocaleString();
      },
    },
    colors: [
      "#e0f9ab",
      "#69d2ceb3",
      "#47a9f3c4",
      "#ffcb2db0",
      "#f49323b5",
      "#ffbbca",
      "#53599ab3",
    ],

    xaxis: {
      categories: horizontalAxis,
    },
    yaxis: {
      labels: {
        formatter(value) {
          return value.toLocaleString();
        },
      },
    },
    legend: {
      position: "right",
      offsetY: 40,
    },
    fill: {
      opacity: 1,
    },
  };

  return (
    <>
      <Card style={{ paddingTop: 100, paddingBottom: 100 }}>
        <div id="chart">
          <ReactApexChart
            options={dataOptions}
            series={dataSeries}
            type="bar"
            height={350}
          />
        </div>
      </Card>
    </>
  );
};

export default Mixed;
